import React, { useState, useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { getSearchStats } from '../../services/searchService';


const formatStat = (value) => {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1).replace('.0', '')}M`;
  }
  if (value >= 100000) {
    return `${(value / 100000).toFixed(1).replace('.0', '')}L`;
  }
  return value.toLocaleString();
};

const StatisticsSection = () => {

  const [statsData, setStatsData] = useState({
    searchesDone: 0,
    contactsFound: 0,
    listInsights: 0
  });

  const [loading, setLoading] = useState(true);

  const fetchSearchStats = async () => {
    try {
      const response = await getSearchStats();

      setStatsData({
        searchesDone: response.data.totalSearches,
        contactsFound: response.data.contactsFound,
        listInsights: response.data.insights
      });

    } catch (error) {

      console.error("Failed to fetch stats:", error);
      setStatsData({
        searchesDone: 20000,
        contactsFound: 14000,
        listInsights: 15000
      });

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSearchStats();
  }, []);


  const stats = [
    {
      value: statsData.searchesDone,
      title: 'Searches Completed',
      subtitle: 'Across all industries and roles',
    },
    {
      value: statsData.contactsFound,
      title: 'Prospects Discovered',
      subtitle: 'High-quality signals',
      highlight: true,
    },
    {
      value: statsData.listInsights,
      title: 'Insights Generated',
      subtitle: 'AI-powered candidate analysis',
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        bgcolor: 'white',
        py: { xs: 6, md: 8 },
        borderBottom: '1px solid #f1f5f9',
      }}
    >
      <Container maxWidth="lg">

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >

          {stats.map((stat, index) => (

            <Box
              key={stat.title}
              sx={{
                flex: 1,
                textAlign: 'center',
                py: 3,
                px: 2,
                borderLeft:
                  index !== 0
                    ? { md: '1px solid #e5e7eb' }
                    : 'none',
              }}
            >

              {/* NUMBER */}
              <Typography
                sx={{
                  fontSize: { xs: '2.8rem', md: '3.4rem' },
                  fontWeight: 800,
                  lineHeight: 1,
                  mb: 1,
                  color: stat.highlight ? '#16a34a' : '#111827',
                  letterSpacing: '-0.02em',
                }}
              >
                {loading ? '...' : `${formatStat(stat.value)}+`}
              </Typography>


              {/* TITLE */}
              <Typography
                sx={{
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  color: '#374151',
                  mb: 0.5,
                }}
              >
                {stat.title}
              </Typography>


              {/* SUBTITLE */}
              <Typography
                sx={{
                  fontSize: '0.9rem',
                  color: '#6b7280',
                }}
              >
                {stat.subtitle}
              </Typography>

            </Box>

          ))}

        </Box>

      </Container>
    </Box>
  );
};

export default StatisticsSection;